import styled from 'styled-components'
import colors from 'globals/colors'

export const MailProcessingWrapper = styled.div`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;

  & > svg {
    margin-right: 8px;
    vertical-align: middle;

    &.green {
      & .color-fill {
        fill: ${colors.blueGreen} !important;
      }
    }

    &.yellow {
      & .color-fill {
        fill: ${colors.apricot} !important;
      }
    }
    
    &.grey {
      & .color-fill {
        fill: ${colors.lightGrey} !important;
      }
    }
  }
  @media (max-width: 405px) {
      display: none;
  }
`
